import type { GovernanceCheckCommitRequest } from '$/requests/GovernanceCheck.ts';
import type { RecommendationEngineData } from '@/pages/recommendationEngine/recommendationEngineContext.ts';

export function buildGovernanceCheckRequest(
  d: Partial<RecommendationEngineData>,
): GovernanceCheckCommitRequest {
  if (!d.decision_id) throw new Error('decision_id is required');
  if (d.framework_logic_match !== 'yes') throw new Error('framework_logic_match must be yes');
  if (d.commitment_confidence == null || d.commitment_confidence < 1 || d.commitment_confidence > 5) {
    throw new Error('commitment_confidence is required');
  }
  if (!d.primary_assumption?.trim()) throw new Error('primary_assumption is required');

  return {
    decision_id: d.decision_id,
    commitment_confidence: d.commitment_confidence,
    primary_assumption: d.primary_assumption.trim(),
    framework_logic_match: 'yes',
    ...(d.save_session_language != null ? { save_session_language: d.save_session_language } : {}),
  };
}
